import SentryLogger from './SentryLogger';

const Logger = new SentryLogger();

export default Logger;
